import { useEffect, useState } from "react";

const orientationMediaQuery = window.matchMedia("(orientation: portrait)");

export default function useIsPortrait() {
  const [isPortrait, setIsPortrait] = useState(orientationMediaQuery.matches);

  useEffect(() => {
    function changeOrientation(e: MediaQueryListEvent) {
      console.log(e);
      setIsPortrait(e.matches);
    }

    orientationMediaQuery.addEventListener("change", changeOrientation);

    return () => {
      orientationMediaQuery.removeEventListener("change", changeOrientation);
    };
  }, []);

  return isPortrait;
}
